module.exports = __webpack_public_path__ + "img/745.4a00f901.gif";